const option = [
    { id: 'tire', name: 'ยางรถยนต์' },
    { id: 'engine', name: 'น้ำมันเครื่อง' },
    { id: 'battery', name: 'แบตเตอรี่' },
    { id: 'brake', name: 'เบรค' },
    { id: 'absorber', name: 'โช๊คอัพ' },
    { id: 'wheel', name: 'ล้อแม็ก' },
    { id: 'part', name: 'อะไหล่' },
    { id: 'other', name: 'อื่นๆ' }
]

export default {
    option: option
};